/* NordicSmile Store v3 (2026-10-07) - drobne interakcje sklepu (bez zależności). */
(function () {
  'use strict';
  var mqDesk = window.matchMedia('(min-width: 990px)');

  /* Stopka: kolumny jako akordeony na telefonie, otwarte na komputerze */
  function footerCols() {
    var cols = document.querySelectorAll('.nss-fcol');
    for (var i = 0; i < cols.length; i++) {
      if (mqDesk.matches) cols[i].setAttribute('open', '');
      else cols[i].removeAttribute('open');
    }
  }
  footerCols();
  if (mqDesk.addEventListener) mqDesk.addEventListener('change', footerCols);

  /* Wideo w sekcji "Wyróżniony produkt": autoodtwarzanie bez dźwięku w widoku, przycisk = pełny ekran z dźwiękiem */
  var vids = document.querySelectorAll('video[data-nss-video]');
  function startVideo(v) {
    if (!v.src && v.dataset.src) v.src = v.dataset.src;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) startVideo(v);
        else if (!v.paused && !v.dataset.full) v.pause();
      });
    }, { rootMargin: '120px 0px' });
    for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
  } else {
    for (var k = 0; k < vids.length; k++) startVideo(vids[k]);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nss-video-open]');
    if (!btn) return;
    var v = btn.parentNode.querySelector('video[data-nss-video]');
    if (!v) return;
    startVideo(v);
    v.muted = false;
    v.controls = true;
    v.dataset.full = '1';
    var req = v.requestFullscreen || v.webkitRequestFullscreen || v.webkitEnterFullscreen;
    if (req) { try { req.call(v); } catch (err) {} }
    btn.hidden = true;
  });
  function onFsChange() {
    var fs = document.fullscreenElement || document.webkitFullscreenElement;
    if (fs) return;
    for (var i = 0; i < vids.length; i++) {
      if (vids[i].dataset.full) {
        vids[i].muted = true; vids[i].controls = false; delete vids[i].dataset.full;
        var b = vids[i].parentNode.querySelector('[data-nss-video-open]');
        if (b) b.hidden = false;
      }
    }
  }
  document.addEventListener('fullscreenchange', onFsChange);
  document.addEventListener('webkitfullscreenchange', onFsChange);
  for (var m = 0; m < vids.length; m++) vids[m].addEventListener('webkitendfullscreen', onFsChange);

  /* ---------- Karta produktu: pakiety, galeria, przyklejony przycisk ---------- */
  function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i], i); }

  function initPdp(root) {
    if (!root || root.getAttribute('data-nss-ready')) return;
    root.setAttribute('data-nss-ready', '1');
    var vid = root.querySelector('[data-nss-vid]');
    var qty = root.querySelector('[data-nss-qty]');
    var btnPrice = root.querySelector('[data-nss-btn-price]');
    var stTitle = root.querySelector('[data-nss-st-title]');
    var mainAtc = root.querySelector('[data-nss-main-atc]');
    var sticky = root.querySelector('[data-nss-sticky]');
    var stickyAtc = root.querySelector('[data-nss-sticky-atc]');
    var gal = root.querySelector('[data-nss-gal]');
    var track = root.querySelector('[data-nss-gal-track]');
    var cur = root.querySelector('[data-nss-gal-cur]');
    var thumbs = root.querySelectorAll('[data-nss-gal-go]');
    var buy = root.querySelector('[data-nss-buy]');

    /* pakiety: wariant, ilość, ceny w przycisku i na pasku */
    function applyPack(inp) {
      var d = inp.dataset;
      var hasOld = Number(d.compare) > Number(d.price);
      each(root.querySelectorAll('.nss-pk'), function (l) { l.classList.toggle('is-on', l.contains(inp)); });
      if (vid) vid.value = inp.value;
      if (qty) qty.value = d.qty || '1';
      each(root.querySelectorAll('[data-nss-now]'), function (el) { el.textContent = d.priceF; });
      each(root.querySelectorAll('[data-nss-old]'), function (el) { el.textContent = d.compareF; el.hidden = !hasOld; });
      each(root.querySelectorAll('[data-nss-save]'), function (el) { el.hidden = !hasOld; });
      each(root.querySelectorAll('[data-nss-save-v]'), function (el) { el.textContent = d.saveF; });
      if (btnPrice) btnPrice.textContent = d.priceF;
      if (stTitle) stTitle.textContent = d.title;
    }
    root.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp || !inp.matches || !inp.matches('.nss-pk input[type="radio"]')) return;
      applyPack(inp);
      var radios = root.querySelectorAll('.nss-pk input[type="radio"]');
      var multiVariant = radios.length > 1 && radios[0].value !== radios[radios.length - 1].value;
      if (multiVariant && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', inp.value);
          history.replaceState(history.state, '', u.toString());
        } catch (err) {}
      }
    });

    /* galeria: licznik i miniatury (telefon), "pokaż wszystkie" (komputer) */
    function setCur(i) {
      if (cur) cur.textContent = String(i + 1);
      each(thumbs, function (t, k) { t.classList.toggle('is-on', k === i); });
      var th = thumbs[i];
      if (th && th.parentNode) {
        var box = th.parentNode;
        var left = th.offsetLeft - (box.clientWidth - th.offsetWidth) / 2;
        try { box.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); } catch (err) { box.scrollLeft = Math.max(0, left); }
      }
    }
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = 0;
          if (track.scrollWidth <= track.clientWidth + 2) return;
          setCur(Math.round(track.scrollLeft / track.clientWidth));
        });
      }, { passive: true });
    }
    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var t = e.target.closest('[data-nss-gal-go]');
      if (t && track) {
        var i = Number(t.getAttribute('data-nss-gal-go')) || 0;
        try { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); } catch (err) { track.scrollLeft = i * track.clientWidth; }
        setCur(i);
        return;
      }
      var more = e.target.closest('[data-nss-gal-all]');
      if (more && gal) {
        gal.classList.add('is-all');
        more.hidden = true;
        fit();
      }
    });

    /* komputer: kolumna zakupu przyklejona tylko, gdy mieści się w oknie */
    function fit() {
      if (!buy) return;
      var ok = mqDesk.matches && buy.offsetHeight + 48 < window.innerHeight;
      buy.classList.toggle('is-sticky', ok);
    }
    fit();
    window.addEventListener('resize', fit);
    if (buy) buy.addEventListener('toggle', fit, true);

    /* telefon: przyklejony przycisk po przewinięciu poza główny przycisk, chowany przy stopce */
    if (sticky && mainAtc && stickyAtc && 'IntersectionObserver' in window) {
      var pastAtc = false, footIn = false;
      function upd() {
        var on = pastAtc && !footIn && !mainAtc.disabled;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        stickyAtc.tabIndex = on ? 0 : -1;
      }
      new IntersectionObserver(function (es) {
        each(es, function (en) { pastAtc = !en.isIntersecting && en.boundingClientRect.top < 0; });
        upd();
      }).observe(mainAtc);
      var foot = document.querySelector('.nss-foot') || document.querySelector('footer');
      if (foot) {
        new IntersectionObserver(function (es) {
          each(es, function (en) { footIn = en.isIntersecting; });
          upd();
        }).observe(foot);
      }
      stickyAtc.addEventListener('click', function () { mainAtc.click(); });
    }
  }
  each(document.querySelectorAll('[data-nss-pdp]'), initPdp);
  document.addEventListener('shopify:section:load', function (e) {
    each(e.target.querySelectorAll ? e.target.querySelectorAll('[data-nss-pdp]') : [], initPdp);
  });
})();
